// Types
import type { ItemType } from "pages/Accounts/Transaction/OpeningBalance/utils"

export const getOpeningBalance = (list: ItemType[], group_coa_id: number) => {
  return list.find(item => item.group_coa_id === group_coa_id && item.parent_id === -1)?.opening_balance ?? 0
}